import { useState } from "react";
import { Loader2, AlertTriangle, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PdfViewerProps {
  url: string;
  className?: string;
}

export function PdfViewer({ url, className = "" }: PdfViewerProps) {
  const [loadError, setLoadError] = useState(false);
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={`relative flex flex-col ${className}`} style={{ minHeight: 400 }}>
      {!loaded && !loadError && (
        <div className="absolute inset-0 flex items-center justify-center bg-muted/30 rounded">
          <Loader2 className="w-5 h-5 animate-spin text-muted-foreground" />
        </div>
      )}
      {loadError ? (
        <div className="flex flex-col items-center justify-center flex-1 gap-3 py-12 text-muted-foreground">
          <AlertTriangle className="w-6 h-6" />
          <span className="text-sm">Impossible d'afficher le PDF dans le navigateur</span>
          <Button size="sm" variant="outline" asChild>
            <a href={url} target="_blank" rel="noopener noreferrer">
              <ExternalLink className="w-4 h-4 mr-1.5" />
              Ouvrir dans un nouvel onglet
            </a>
          </Button>
        </div>
      ) : (
        <iframe
          src={url}
          title="Aperçu PDF"
          className={`w-full flex-1 rounded border-0 ${loaded ? "" : "opacity-0"}`}
          style={{ minHeight: 400 }}
          onLoad={() => setLoaded(true)}
          onError={() => setLoadError(true)}
        />
      )}
    </div>
  );
}
